<template>
    <UiCoreNavigation v-editable="blok" id="uiHeader" :logo-height="64" :blok="blok" @logout="logout" />
</template>

<script lang="ts" setup>
import { useAuthStore } from '@nuxt-monorepo/base/app/store/auth';

defineProps<{ blok: any }>();
const authStore = useAuthStore();
const route = useRoute();

async function logout() {
    await $publicApi('logout', {
        method: 'POST',
        body: { _token: authStore.csrf },
        onResponse({ response }) {
            if (response.ok) {
                navigateTo(route.path, { external: true });
            }
        },
        onResponseError({ response }) {
            if (response) {
                console.error(response);
            }
        },
    });
}
</script>

<style lang="postcss">
#uiHeader {
    @apply bg-white shadow-[0_0_5px_0_rgba(0,0,0,0.25)] relative;

    &.navigation {
        .navigation__menu {
            @apply lg:justify-end;
        }

        > .navigation__wrapper.container {
            @apply py-0 h-[56px] lg:h-[66px];
        }
    }

    > .container {
        @apply py-2 max-md:justify-center;
        .logo img {
            @apply max-md:h-[40px] py-[5px];
        }
        .nav-row-item {
            @apply text-[0.95rem] ml-4 pt-[5px] pb-0 px-2 border-b-[5px] border-b-transparent border-solid;
            > a,
            span {
                @apply text-base text-[#5a5e6b] p-2;
            }

            .iconify {
                @apply text-[10px];
            }

            .nav-dropdown {
                @apply top-[46px] right-0 bg-white shadow-[0_8px_10px_rgba(0,0,0,0.125)];
                .current-page-nav-item,
                .nav-dropdown-item:hover,
                .nav-mobile-dropdown-item:hover {
                    @apply bg-[#f3f5f8] text-[#151515] border-0;

                    a,
                    span {
                        @apply bg-[transparent];
                    }
                }
            }
        }

        .current-page-nav-item,
        .nav-row-item:hover {
            @apply border-b-[5px] border-b-[#59c2ef] border-solid;

            > a,
            span,
            .iconify {
                @apply text-[#59c2ef];
            }
        }

        .navigation-button {
            @apply items-center justify-end max-md:text-[#59c2ef];
            @apply md:text-[rgba(0,0,0,0.5)] text-base right-4 top-[1.025rem] bottom-auto;
            .iconify {
                @apply text-[22px];
            }
        }

        .mobile-menu {
            @apply block absolute top-0 right-0 transform translate-x-full transition-transform ease-in-out duration-[500ms];
            @apply bottom-0 w-[75vw] bg-white z-50 h-[calc(100vh)] pl-0 pt-0 overflow-y-scroll top-[56px];
            @apply shadow-[-3px_-4px_20px_0_rgba(0,0,0,0.1)];
            @apply md:hidden;

            &.active {
                @apply transform translate-x-0;
            }

            .close-button {
                @apply hidden;
            }

            .level-1 {
                li {
                    @apply text-[#5a5e6b] px-6 py-4 border-b-[#ccc] border-b border-solid mb-0;
                    a {
                        @apply pl-6;
                        > .iconify {
                            @apply right-auto left-0;
                        }
                    }
                }
            }
        }
    }

    .mobile-nav-bg {
        @apply max-md:block max-md:top-[56px] absolute;
    }

    .mobile-fall-menu {
        @apply border-t-2 border-t-[#eee] border-solid py-2 px-4;
        @apply shadow-[0_10px_5px_rgba(0,0,0,0.25)] w-4/5 translate-x-[10%];

        .level-1 {
            li {
                &.current-page-nav-item,
                &:hover {
                    @apply text-[#59c2ef];
                }
                a {
                    @apply py-2 text-left px-4;
                    .iconify {
                        @apply text-[10px];
                    }
                }

                .nav-mobile-dropdown {
                    @apply pl-4;
                    li {
                        @apply text-[#5a5e6b];
                        &:hover {
                            @apply bg-[#f3f5f8] text-[#151515] border-0;
                            a,
                            span {
                                @apply bg-[transparent];
                            }
                        }

                        a {
                            @apply pl-5 py-2;
                        }
                    }
                }
            }
        }
    }
}
</style>
